import { Fragment, useEffect, useState } from "react";
import { HeadingTitle } from "../ModalContainer";
import secureLocalStorage from "react-secure-storage";
import { useDispatch, useSelector } from "react-redux";
import {
  getBatchDetailsActions,
  MarkHoldActions,
} from "../../../Actions/ProductionActions";
import Loading from "../../Loading/Loading";
import DataTable from "../../DataTable/DataTable";
import NoData from "../../Loading/NoData";
import { toast } from "react-toastify";

const BatchDetailHeader = [
  "Sr. No",
  "Process Name",
  "Pending Qty",
  "Aging",
  "Hold Qty",
  "Actions",
];

const BatchDetails = ({ close, batch_id }) => {
  const dispatch = useDispatch();

  //   Batch Details State
  const { batchDetails, loading } = useSelector((state) => state.BatchDetails);

  //   Mark Hold State
  const { markHold, loading: markHoldLoading } = useSelector(
    (state) => state.MarkHold
  );

  const token = JSON.parse(secureLocalStorage.getItem("user_UUID_MFG"))?.token;
  console.log("TOKEN: ", token);

  console.log("BATCH ID: ", batch_id);

  useEffect(() => {
    if (batch_id) {
      dispatch(getBatchDetailsActions("batch_node_detail", token, batch_id));
    }
  }, [batch_id, token, dispatch]);

  console.log("BATCH DETAILS: ", batchDetails);

  const [activeMarkHoldIndex, setActiveMarkHoldIndex] = useState(null);

  const [isMarkedHold, setIsMarkedHold] = useState(false);

  const handleMarkHold = (index, process_node_id) => {
    if (batch_id) {
      setIsMarkedHold(true);
      setActiveMarkHoldIndex(index);
      dispatch(
        MarkHoldActions("inventory_wip_hold", token, batch_id, process_node_id)
      );
    } else {
      toast.error("Batch id is Required.");
    }
  };

  console.log("MARK HOLD");

  useEffect(() => {
    if (markHold && markHold?.status === 1 && isMarkedHold) {
      toast.success(markHold?.msg || "Success");
      setIsMarkedHold(false);
    }
    if (markHold && markHold?.status === 0 && isMarkedHold) {
      toast.error(markHold?.msg || "Error");
      setIsMarkedHold(false);
    }
  }, [markHold, isMarkedHold]);

  return (
    <Fragment>
      <HeadingTitle title={`Batch Details`} center={false} closeModal={close} />

      <div className="table-wrapper-pagination mtx-5x">
        <div className="table-container-pagination">
          {loading ? (
            <Loading loading={loading} color={"rgba(1, 18, 34, 1)"} size={42} />
          ) : (
            <>
              {batchDetails && batchDetails?.data?.length > 0 ? (
                <DataTable
                  items_per_page={10}
                  page={1}
                  header={BatchDetailHeader}
                  batchDetails={batchDetails && batchDetails?.data}
                  handleMarkHold={handleMarkHold}
                  markHoldLoading={markHoldLoading}
                  activeMarkHoldIndex={activeMarkHoldIndex}
                />
              ) : (
                <NoData title={"No Results Found"} />
              )}
            </>
          )}
        </div>
      </div>
    </Fragment>
  );
};

export default BatchDetails;
